<template>
  <ul class="navbar-nav flex-row toolBar">
    <!-- <li class="nav-item _hidden d-none d-lg-block" v-if="userInfo.hasPay">
      <a
        class="nav-link px-lg-3 _mustread d-flex align-items-center"
        :href="mustReadApiPage"
        target="_blank"
      >
        <i class="pz-icon icon-help mr-1 _sm"></i>学员必读
      </a>
    </li> -->
    <!-- <li class="nav-item _hidden d-none d-lg-block">
      <a
        :href="`${redirectUrl.MALL_PAGE}`"
        class="nav-link px-lg-3 d-flex align-items-center"
      >
        <i class="pz-icon icon-study mr-1 _sm"></i>品职商城
      </a>
    </li> -->
    <!-- <li class="nav-item _hidden d-none d-lg-block">
      <router-link
        to="/referral"
        class="nav-link px-lg-3 d-flex align-items-center"
        href="javascript:undefined"
      >
        <span class="text-dark">🧧</span>邀请好友
      </router-link>
    </li>-->
    <template v-if="!unLogin && mg_tutorinfo">
      <li class="nav-item dropdown">
        <a
          class="nav-link hvr-icon-grow-rotate d-flex align-items-center"
          href="javascript:undefined"
          id="navbarDropdown"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i class="pz-icon icon-vip-1v1 mr-1"></i>
          辅导员
        </a>
        <div
          class="dropdown-menu dropdown-menu-right dropdown-contact position-absolute shadow"
          aria-labelledby="navbarDropdown"
        >
          <div class="px-3 py-1 text-center">
            <p class="my-1">添加您的专属辅导员</p>

            <img :src="mg_tutorinfo.tutorQrCode" width="180" height="180" />
          </div>
          <div class="dropdown-divider my-0"></div>
          <div class="p-3 text-center">
            {{ mg_tutorinfo.tutorName }} <br />
            <small>（ {{ mg_tutorinfo.tutorHoliday }} ）</small>
          </div>
        </div>
      </li>
      <li class="nav-item">
        <span class="nav-link text-muted mr-2 ml-3">|</span>
      </li>
    </template>

    <!-- <li class="nav-item _hidden mx-2">
      <router-link
        to="/im"
        class="nav-link hvr-icon-grow-rotate"
        href="javascript:undefined"
      >
        <i class="pz-icon icon-chat mr-1 hvr-icon"></i>
        <span
          class="badge badge-pill badge-danger _badge-dot"
          v-if="hasNewMessages"
        ></span>
      </router-link>
    </li> -->
    <li class="nav-item dropdown d-none d-lg-block">
      <a class="nav-link hvr-icon-grow-rotate" :href="mustReadApiPage" target="_blank">
        <i class="pz-icon icon-help hvr-icon"></i>
      </a>
    </li>
    <li class="nav-item dropdown" v-if="!unLogin">
      <router-link to="/message" class="nav-link hvr-icon-grow-rotate" href="javascript:undefined">
        <i class="pz-icon icon-chat hvr-icon"></i>
        <span class="badge badge-pill badge-danger _badge-dot" v-if="hasNewMessages"></span>
        <!-- <span id='hasNewMessagesIM' class="badge badge-pill badge-danger _badge-dot"
        ></span> -->
      </router-link>
    </li>

    <li class="nav-item dropdown" v-if="!unLogin">
      <a
        class="nav-link"
        href="javascript:undefined"
        id="navbarDropdown"
        role="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <img
          :src="avatar"
          width="30px"
          height="30px"
          class="rounded-circle object-fit-cover mt-n1"
        />
      </a>
      <div
        class="dropdown-menu dropdown-menu-right dropdown-user position-absolute shadow py-0 mt-n2"
        aria-labelledby="navbarDropdown"
      >
        <div class="card-body align-items-center d-none d-lg-block">
          <div class="media">
            <img :src="avatar" width="40px" height="40px" class="rounded-circle mr-3" />
            <div class="media-body">
              <h5 class="mb-0">{{ nickName }}</h5>
              <p class="small text-secondary mb-0">学号：PZ.{{ userInfo.studentIdText }}</p>
            </div>
            <a href="javascript:undefined" class="text-danger" id="logout" @click.prevent="logout"
              >退出</a
            >
          </div>
        </div>

        <div class="d-flex border-top py-3 mx-3 border-bottom align-items-center">
          积分：{{ bonusPoint }}
          <router-link to="/points" class="d-lg-none">明细/充值</router-link>
          <router-link to="/points" class="ml-auto btn btn-primary btn-sm d-none d-lg-block"
            >明细/充值</router-link
          >
        </div>

        <div class="card-body">
          <div class="row mx-n1">
            <div class="col-6 px-1 mb-1">
              <router-link
                to="/my-order"
                class="btn btn-light btn-sm d-flex align-items-center flex-column"
              >
                <i class="pz-icon icon-exam-list"></i>我的订单
              </router-link>
            </div>
            <div class="col-6 px-1 mb-1">
              <router-link
                to="/referral"
                class="btn btn-light btn-sm d-flex align-items-center flex-column"
              >
                <i class="pz-icon icon-referral"></i>邀请码
              </router-link>
            </div>
            <div class="col-6 px-1 mb-1">
              <router-link
                to="/coupon"
                class="btn btn-light btn-sm d-flex align-items-center flex-column"
              >
                <i class="pz-icon icon-coupon"></i>优惠券
              </router-link>
            </div>
            <div class="col-6 px-1 mb-1">
              <router-link
                to="/setting"
                class="btn btn-light btn-sm d-flex align-items-center flex-column"
              >
                <i class="pz-icon icon-person-info"></i>个人设置
              </router-link>
            </div>
          </div>

          <!-- <a
            :href="mustReadApiPage"
            target="_blank"
            class="btn btn-link text-dark btn-sm d-flex flex-lg-column d-lg-none"
          >
            <i class="pz-icon icon-info mb-lg-2 mr-3 mr-lg-0"></i>学员必读
          </a>
          <div class="dropdown-divider d-lg-none"></div>
          
         
          <div class="dropdown-divider d-lg-none"></div>
          <a
            href="javascript:undefined"
            class="btn btn-link text-dark btn-sm d-flex flex-lg-column d-lg-none"
            @click.prevent="logout"
          >
            <i class="pz-icon icon-logout mb-lg-2 mr-3 mr-lg-0"></i>退出
          </a> -->
        </div>

        <!-- <div class="dropdown-divider"></div> -->

        <!-- <a :href="portalURL.INDEX"
           class="dropdown-item py-2 d-flex">
          <i class="pz-icon icon-home mr-3 text-black-50 "></i>官网首页
        </a>-->
        <!-- <a :href="portalURL.APP" class="dropdown-item py-2">
          <i class="pz-icon icon-app-download mr-3 ml-2 text-black-50"></i>App下载
        </a>-->
      </div>
    </li>
    <!-- <li class="nav-item mx-2 exit d-none d-xl-block">
      <span class="nav-link">|</span>
    </li>
    <li class="nav-item mx-3 exit d-none d-xl-block">
      <a :href="portalURL.INDEX" class="nav-link">
        返回首页
      </a>
    </li>-->
  </ul>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { /* LANDING_PAGE, */ MUST_READ_API_PAGE } from '../constants/routes';
import { REDIRECT_URLS } from '../constants';

export default {
  name: 'ToolBar',
  data: () => {
    return {
      mustReadApiPage: MUST_READ_API_PAGE,
      redirectUrl: {
        ...REDIRECT_URLS,
      },
    };
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
      mg_tutorinfo: 'tutorinfo',
    }),

    unLogin() {
      return this.userInfo.unLogin || undefined === this.userInfo.unLogin;
    },

    avatar() {
      return this.userInfo.avatar;
    },

    nickName() {
      return this.userInfo.nickname;
    },

    bonusPoint() {
      return this.userInfo.bonusPoint;
    },

    hasNewMessages() {
      return this.userInfo.hasNewMessages;
    },
  },

  methods: {
    ...mapActions({
      ma_logout: 'logout',
    }),

    async logout() {
      await this.ma_logout();
      // window.parent.postMessage(
      //   { message: 'comlogout' },
      //   'http://www.pzacademy.cn'
      // );
      //this.$router.push(LANDING_PAGE);
      window.location.href = REDIRECT_URLS.LANDING_PAGE;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped type="text/css">
.dashboard ._mustread {
  color: #f80 !important;
}
</style>
